import React from 'react';
import Icon from '../Icon';
import { translate } from '../../Services/translation';
import { Retailer } from '../../Types/Retailer';

interface RetailerListTopBarProps {
  showMap: boolean;
  setShowMap: (showMap: boolean) => void;
  retailersAmount: number;
  setActiveRetailer: (retailer: Retailer | null) => void;
  activeRetailer: Retailer | null;
}

const RetailerListTopBar = ({
  showMap,
  setShowMap,
  retailersAmount,
  setActiveRetailer,
  activeRetailer,
}: RetailerListTopBarProps) => {
  const handleOnShowMapClick = () => {
    if (activeRetailer) {
      let storedRetailer = activeRetailer;
      setActiveRetailer(null);
      setShowMap(true);
      setTimeout(() => {
        setActiveRetailer(storedRetailer);
      }, 200);
    } else {
      setShowMap(true);
    }
  };

  return (
    <div className="my-3 flex items-center justify-between">
      <div className="text-sm uppercase text-gray-500">
        {retailersAmount} {translate('retailers.retailers')}
      </div>
      <div className="flex gap-6">
        <button
          className="flex items-center gap-2 py-2.5 text-sm uppercase text-gray-700"
          onClick={() => handleOnShowMapClick()}
        >
          {showMap ? (
            <Icon name="map-pin-fill" className="h-5 w-5" />
          ) : (
            <Icon name="map-pin-light" className="h-5 w-5" />
          )}
          <span className="hidden lg:flex">
            {translate('retailers.show-map')}
          </span>
        </button>
        <button
          className="flex items-center gap-2 py-2.5 text-sm uppercase text-gray-700"
          onClick={() => setShowMap(false)}
        >
          {!showMap ? (
            <Icon name="rows-fill" className="h-5 w-5" />
          ) : (
            <Icon name="two-rows-light" className="h-5 w-5" />
          )}
          <span className="hidden lg:flex">
            {translate('retailers.show-list')}
          </span>
        </button>
      </div>
    </div>
  );
};

export default RetailerListTopBar;
